/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { SMT, SMTInterface } from '../../imports/SMT';

const _abi = [
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'bitmap',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_proofs',
        type: 'bytes32[]',
      },
      {
        internalType: 'uint8',
        name: '_bits',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: '_index',
        type: 'uint256',
      },
      {
        internalType: 'bytes32',
        name: '_leaf',
        type: 'bytes32',
      },
    ],
    name: 'compute',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'a',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 'b',
        type: 'bytes32',
      },
    ],
    name: 'hash',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_proofs',
        type: 'bytes32[]',
      },
      {
        internalType: 'uint8',
        name: '_bits',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: '_index',
        type: 'uint256',
      },
      {
        internalType: 'bytes32',
        name: '_leaf',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: '_expectedRoot',
        type: 'bytes32',
      },
    ],
    name: 'validate',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: '_proofs',
        type: 'bytes32[]',
      },
      {
        internalType: 'uint8',
        name: '_bits',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: '_index',
        type: 'uint256',
      },
      {
        internalType: 'bytes32',
        name: '_nextLeaf',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: '_prevLeaf',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: '_prevRoot',
        type: 'bytes32',
      },
    ],
    name: 'write',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
];

const _bytecode =
  '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';

type SMTConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: SMTConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SMT__factory extends ContractFactory {
  constructor(...args: SMTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'SMT';
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<SMT> {
    return super.deploy(overrides || {}) as Promise<SMT>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): SMT {
    return super.attach(address) as SMT;
  }
  override connect(signer: Signer): SMT__factory {
    return super.connect(signer) as SMT__factory;
  }
  static readonly contractName: 'SMT';

  public readonly contractName: 'SMT';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SMTInterface {
    return new utils.Interface(_abi) as SMTInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): SMT {
    return new Contract(address, _abi, signerOrProvider) as SMT;
  }
}
